import { useTheme } from "@emotion/react";
import { Divider } from "@fullscript/aviary-web";

import { SvgFullscriptIcon, SvgFullscriptIconDarkGreen } from "@shared/assets/logo";
import FullscriptLogoGreenLeafPigeonTextSVGComponent from "@shared/assets/logo/FullscriptLogoGreenLeafPigeonText";
import FullscriptLogoWhiteTextGreenLeafSVGComponent from "@shared/assets/logo/FullscriptLogoWhiteTextGreenLeaf";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./StoreLandingPageNavBar.styles";

interface Props {
  isPreview?: boolean;
  isStorefronts?: boolean;
  iconLogo?: string;
}

const StoreLandingPageNavBar = ({ isPreview, isStorefronts = false, iconLogo }: Props) => {
  const { tablet } = useBreakpoints();
  const currentTheme = useTheme();
  const theme = useTheme();

  const shouldShowCoBranding = isStorefronts && !isPreview;

  const renderFsCobrandingLogo = () => {
    if (currentTheme.theme === "dark") {
      return <SvgFullscriptIcon />;
    }

    return <SvgFullscriptIconDarkGreen />;
  };

  const renderLogo = () => {
    if (shouldShowCoBranding) {
      return (
        <div css={styles.homeWithCoBranding}>
          {renderFsCobrandingLogo()}
          {!!iconLogo && (
            <>
              <Divider customCss={styles.divider(currentTheme)} />
              <img src={iconLogo} css={styles.coBrandingLogo} alt="" />
            </>
          )}
        </div>
      );
    }

    if (theme.theme === "dark") {
      return (
        <FullscriptLogoWhiteTextGreenLeafSVGComponent
          css={styles.svgContainer}
          data-testid="fullscript-logo-dark"
        />
      );
    }

    return (
      <FullscriptLogoGreenLeafPigeonTextSVGComponent
        css={styles.svgContainer}
        data-testid="fullscript-logo"
      />
    );
  };

  if (!tablet.lessThan) {
    return null;
  }

  return <div css={styles.navBar}>{renderLogo()}</div>;
};

export { StoreLandingPageNavBar };
